module.exports = __webpack_public_path__ + "img/logo.0a71d217.png";